/* iHome Kitchen v4 — Theme JS */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 200000; // Rs. 2000 in paisa

  /* ── Announcement Bar ── */
  var annClose = document.getElementById('annClose');
  var annBar = document.getElementById('annBar');
  if (annClose && annBar) {
    annClose.addEventListener('click', function () {
      annBar.style.display = 'none';
      try { sessionStorage.setItem('annClosed', '1'); } catch(e){}
    });
  }
  try { if (sessionStorage.getItem('annClosed') && annBar) annBar.style.display = 'none'; } catch(e){}

  /* ── Sticky Header ── */
  var hdr = document.getElementById('siteHeader');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── Search ── */
  var searchToggle = document.getElementById('searchToggle');
  var searchBar = document.getElementById('hdrSearchBar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('open');
      if (open) setTimeout(function () {
        var inp = document.getElementById('searchInput');
        if (inp) inp.focus();
      }, 100);
    });
  }
  window.doSearch = function () {
    var inp = document.getElementById('searchInput');
    var q = inp ? inp.value.trim() : '';
    if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
  };
  var sInp = document.getElementById('searchInput');
  if (sInp) sInp.addEventListener('keydown', function (e) { if (e.key === 'Enter') doSearch(); });

  /* ── Mobile Drawer ── */
  var burger = document.getElementById('hdrBurger');
  var mobDrawer = document.getElementById('mobDrawer');
  var mobOverlay = document.getElementById('mobOverlay');
  var mobClose = document.getElementById('mobClose');

  function openMob() {
    if (mobDrawer) mobDrawer.classList.add('open');
    if (mobOverlay) mobOverlay.classList.add('open');
    if (burger) { burger.classList.add('open'); burger.setAttribute('aria-expanded', 'true'); }
    document.body.style.overflow = 'hidden';
  }
  window.closeMob = function () {
    if (mobDrawer) mobDrawer.classList.remove('open');
    if (mobOverlay) mobOverlay.classList.remove('open');
    if (burger) { burger.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }
    document.body.style.overflow = '';
  };
  if (burger) burger.addEventListener('click', function() {
    if (mobDrawer && mobDrawer.classList.contains('open')) {
      closeMob();
    } else {
      openMob();
    }
  });
  if (mobClose) mobClose.addEventListener('click', closeMob);
  if (mobOverlay) mobOverlay.addEventListener('click', closeMob);

  /* ── Cart Drawer ── */
  var cartOverlay = document.getElementById('cartOverlay');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartToggle = document.getElementById('cartToggle');
  var cdClose = document.getElementById('cdClose');
  var cdContinue = document.getElementById('cdContinue');

  window.openCart = function () {
    refreshCart();
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeCart = function () {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cdClose) cdClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cdContinue) cdContinue.addEventListener('click', closeCart);

  /* Free shipping progress */
  function updateProgress(total) {
    var fill = document.getElementById('cdProgressFill');
    var text = document.getElementById('cdProgressText');
    if (!fill || !text) return;
    var pct = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
    fill.style.width = pct + '%';
    if (total >= FREE_SHIPPING_THRESHOLD) {
      text.innerHTML = '🎉 You\'ve unlocked <strong>FREE Delivery!</strong>';
    } else {
      var rem = Math.ceil((FREE_SHIPPING_THRESHOLD - total) / 100).toLocaleString();
      text.innerHTML = '🎁 Congratulations! Enjoy Free Delivery on Your Order!';
    }
  }

  function updateCartBadge(count) {
    var badge = document.getElementById('cartBadge');
    var cdCount = document.getElementById('cdCount');
    if (badge) badge.textContent = count;
    if (cdCount) cdCount.textContent = '(' + count + ')';
  }

  window.refreshCart = function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        updateProgress(cart.total_price);
        var totalEl = document.getElementById('cdTotal');
        if (totalEl) totalEl.textContent = 'Rs. ' + (cart.total_price / 100).toLocaleString();
        var body = document.getElementById('cdBody');
        var foot = document.getElementById('cdFoot');
        if (!body) return;

        if (cart.item_count === 0) {
          body.innerHTML = '<div class="cd-empty"><i class="fas fa-bag-shopping"></i><p>Your Bag is empty</p><a href="/collections/all" class="btn btn-primary btn-sm" onclick="closeCart()">Shop Now</a></div>';
          if (foot) foot.style.display = 'none';
          return;
        }
        if (foot) foot.style.display = '';

        var html = '';
        cart.items.forEach(function (item) {
          var imgUrl = item.featured_image && item.featured_image.url
            ? item.featured_image.url.replace(/(\.[a-z]+(\?.*)?$)/, '_140x140$1')
            : null;
          var img = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '<div class="cd-item-img-ph">🍳</div>';
          var varHtml = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="cd-item-var">' + item.variant_title + '</div>' : '';
          html += '<div class="cd-item">'
            + '<div class="cd-item-img">' + img + '</div>'
            + '<div class="cd-item-info">'
            + '<div class="cd-item-name">' + item.product_title + '</div>'
            + varHtml
            + '<div class="cd-item-price">Rs. ' + (item.price / 100).toLocaleString() + '</div>'
            + '<div class="cd-item-qty">'
            + '<button class="cd-qty-btn" onclick="cdQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>'
            + '<span class="cd-qty-num">' + item.quantity + '</span>'
            + '<button class="cd-qty-btn" onclick="cdQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>'
            + '</div>'
            + '<span class="cd-item-remove" onclick="cdQty(\'' + item.key + '\',0)">Remove</span>'
            + '</div></div>';
        });
        body.innerHTML = html;
        if (totalEl) totalEl.textContent = 'Rs. ' + (cart.total_price / 100).toLocaleString();
      })
      .catch(function (e) { console.warn('Cart refresh:', e); });
  };

  window.cdQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function () { refreshCart(); });
  };

  /* ── Add to Cart (product grid) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.prod-atc[data-id]');
    if (!btn || !btn.dataset.id) return;
    var orig = btn.innerHTML;
    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
    btn.classList.add('loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.dataset.id), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.innerHTML = '<i class="fas fa-check"></i> Added!';
        btn.classList.add('added');
        openCart();
        setTimeout(function () {
          btn.innerHTML = orig;
          btn.classList.remove('loading', 'added');
        }, 900);
      })
      .catch(function () { btn.innerHTML = orig; btn.classList.remove('loading'); });
  });

  /* ── Scroll Reveal ── */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && window.IntersectionObserver) {
    var revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); revObs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    revealEls.forEach(function (el) { revObs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── PDP Thumb ── */
  window.pdpThumb = function (el, src) {
    var img = document.getElementById('pdpMainImg');
    if (img) img.src = src;
    document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
    el.classList.add('active');
  };

  /* ── PDP Variant ── */
  window.pdpVariant = function (el, id) {
    var input = document.getElementById('pdpVariantId');
    if (input) input.value = id;
    document.querySelectorAll('.pdp-var-btn').forEach(function (b) { b.classList.remove('active'); });
    el.classList.add('active');
  };

  /* ── PDP Qty ── */
  window.pdpQty = function (delta) {
    var el = document.getElementById('pdpQtyNum');
    var hiddenInput = document.getElementById('pdpQtyInput');
    if (el) {
      var newVal = Math.max(1, parseInt(el.textContent) + delta);
      el.textContent = newVal;
      if (hiddenInput) hiddenInput.value = newVal;
    }
  };

  /* ── PDP ATC ── */
  var pdpForm = document.getElementById('pdpForm');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('pdpAtcBtn');
      if (!btn) return;

      /* Read the form live via FormData instead of hardcoded element refs.
         This way, if a bundle/quantity-break app (Kaching Bundles, Barn2,
         etc.) injects or overrides hidden inputs (id, quantity, properties,
         items) inside this form, those values are respected automatically
         instead of being silently ignored. */
      var formData = new FormData(pdpForm);
      var payload = {};
      formData.forEach(function (value, key) {
        payload[key] = value;
      });
      if (!payload.id) {
        var vidFallback = document.getElementById('pdpVariantId');
        if (vidFallback) payload.id = vidFallback.value;
      }
      payload.id = parseInt(payload.id, 10);
      payload.quantity = parseInt(payload.quantity, 10) || 1;

      var orig = btn.innerHTML;
      btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
      btn.classList.add('loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) {
            /* Shopify returns {status, message, description} on errors */
            throw new Error(data.description || data.message || 'Add to cart failed');
          }
          btn.innerHTML = '<i class="fas fa-check"></i> Added to Bag!';
          btn.style.background = '#15803D';
          if (window.refreshCart) refreshCart();
          openCart();
          setTimeout(function () {
            btn.innerHTML = orig;
            btn.style.background = '';
            btn.classList.remove('loading');
          }, 1000);
        })
        .catch(function (err) {
          console.warn('Add to cart:', err);
          btn.innerHTML = orig;
          btn.classList.remove('loading');
          alert('Cart mein add nahi ho saka: ' + err.message);
        });
    });
  }

  /* ── Sticky ATC ── */
  var stickyAtc = document.getElementById('stickyAtc');
  var pdpAtcBtn = document.getElementById('pdpAtcBtn');
  if (stickyAtc && pdpAtcBtn && window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      stickyAtc.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(pdpAtcBtn);
  }

  /* ── Reviews Star Picker ── */
  function initStarPicker() {
    var picker = document.querySelector('.rv-star-picker');
    if (!picker) return;
    var stars = picker.querySelectorAll('span');
    var ratingInput = document.getElementById('rvRating');
    stars.forEach(function (star, i) {
      star.style.cursor = 'pointer';
      star.addEventListener('click', function () {
        if (ratingInput) ratingInput.value = i + 1;
        stars.forEach(function (s, j) { s.classList.toggle('lit', j <= i); });
      });
      star.addEventListener('mouseover', function () {
        stars.forEach(function (s, j) { s.classList.toggle('lit', j <= i); });
      });
    });
    picker.addEventListener('mouseout', function () {
      var val = ratingInput ? parseInt(ratingInput.value || '0') : 0;
      stars.forEach(function (s, j) { s.classList.toggle('lit', j < val); });
    });
  }
  initStarPicker();

  window.toggleReviewForm = function () {
    var form = document.getElementById('rvForm');
    if (form) form.classList.toggle('open');
  };

  window.submitReview = function () {
    var name = document.getElementById('rvName');
    var rating = document.getElementById('rvRating');
    var text = document.getElementById('rvText');
    if (!name || !rating || !text) return;
    if (!name.value.trim() || !rating.value || !text.value.trim()) {
      alert('Please fill in all fields and select a rating.');
      return;
    }
    var btn = document.getElementById('rvSubmitBtn');
    if (btn) { btn.textContent = 'Submitting...'; btn.disabled = true; }
    setTimeout(function () {
      var form = document.getElementById('rvForm');
      if (form) form.classList.remove('open');
      var notice = document.getElementById('rvSuccessNotice');
      if (notice) { notice.style.display = 'flex'; setTimeout(function () { notice.style.display = 'none'; }, 4000); }
      if (btn) { btn.textContent = 'Submit Review'; btn.disabled = false; }
      if (name) name.value = '';
      if (text) text.value = '';
      if (rating) rating.value = '';
      document.querySelectorAll('.rv-star-picker span').forEach(function (s) { s.classList.remove('lit'); });
    }, 800);
  };

  /* ── Escape key ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMob(); }
  });

  /* ── Counter Animation ── */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && window.IntersectionObserver) {
    var cObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.dataset.count);
        var suffix = el.dataset.suffix || '';
        var duration = 1600;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.floor(eased * target).toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toLocaleString() + suffix;
        }
        requestAnimationFrame(step);
        cObs.unobserve(el);
      });
    }, { threshold: 0.3 });
    counters.forEach(function (c) { cObs.observe(c); });
  }

})();